import "../../categories/mapPOIS/mapsCss.css";
import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
  MarkerClusterer,
  Polyline,
} from "@react-google-maps/api";
import { LoadingCircle } from "../../UI/spinners/LoadingSpinners";
import GoogleMapStyles from "../GoogleMapStyles";
import { cityCenter } from "../../../../SMARTCITY/hardCodeData/DATA";
import {
  AmeaCategorySingularName,
  formatMapData,
  getMarkerIcon,
} from "../helpers";
import styled from "styled-components";
import {
  myLocationMarker,
  locationOnMarker,
  defaultMarker,
  baseMarker,
} from "./Icons";
import ViewModal from "../container/ViewModal";
import { getLocationData } from "../../../services/services";
import { Button } from "antd";
import { useAllContexts } from "../../../hooks/useAllContexts";
import "./MapAMEA.css";

import availableSpot from "../../../assets/images/p1.png";
import occupiedSpot from "../../../assets/images/p2.png";

const customMarker = "./../../../assets/icons/Map/marker_icon_32x32.png";

const options = {
  imagePath:
    "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
};
const libraries = ["visualization", "places"];

const MapAMEA = ({
  selectedItem,
  selectedRoute,
  rightSideBox,
  data,
  selectedCategory,
  categoryId,
  showNewRoute,
  showInfrastructuresOnNewRoute,
}) => {
  const { newRouteData } = useAllContexts();

  const { isLoaded } = useJsApiLoader({
    id: "google-maps-script",
    googleMapsApiKey: "AIzaSyDQlCnn8F1D0S9ymnWZwc_WFx2ZS6g8w1Q",
    libraries: libraries,
  });

  const [selectedMarkerId, setSelectedMarkerId] = useState(null);

  const [openInfoWindow, setOpenInfoWindow] = useState(false);

  const zoomRef = useRef(15);
  const [map, setMap] = useState(null);
  const [center, setCenter] = useState(cityCenter);
  const [zoomLevel, setZoomLevel] = useState(15);
  const [formattedData, setFormattedData] = useState([]);
  const [formattedSelectedItem, setFormattedSelectedItem] = useState(null);
  const [selectedCoordinates, setSelectedCoordinates] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [positionMarker, setPositionMarker] = useState("");

  useEffect(() => {
    if (data) {
      console.log("TEST: data", data);
      const tempData = data?.map((item) => {
        return formatMapData(categoryId, item, false);
      });
      console.log("TEST: tempData", tempData);
      setFormattedData(tempData);
    }
  }, [data]);

  useEffect(() => {
    if (selectedItem.getItem) {
      setFormattedSelectedItem(
        formatMapData(
          categoryId,
          selectedItem.getItem,
          selectedCategory === "infra" || showNewRoute ? true : false
        )
      );
    } else {
      setFormattedSelectedItem(null);
    }
  }, [selectedItem.getItem]);

  const onLoad = useCallback(function callback(map) {
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);

  useEffect(() => {
    setCenter({
      lat: 37.959477,
      lng: 23.7525442,
    });
  }, [selectedCategory]);

  useEffect(() => {
    if (formattedSelectedItem) {
      setOpenInfoWindow(true);
      setZoomLevel(21);
      setSelectedMarkerId(formattedSelectedItem?.id);
      setCenter({
        lat: formattedSelectedItem?.position.lat,
        lng: formattedSelectedItem?.position.lng,
      });
    } else {
      setSelectedMarkerId(null);
      setOpenInfoWindow(false);
      setZoomLevel(17);
    }
  }, [formattedSelectedItem]);

  const containerStyle = {
    width: "100%",
    height: "100%",
  };

  const setMarkerPosition = (position) => {
    const tempRoute = newRouteData?.get;

    tempRoute[position] = {
      address: selectedLocation?.address.house_number
        ? `${selectedLocation?.address.road} ${selectedLocation?.address.house_number}`
        : selectedLocation?.address.road,
      coordinates: {
        lat: parseFloat(selectedLocation?.lat),
        lng: parseFloat(selectedLocation?.lon),
      },
    };
    newRouteData?.set(position, tempRoute);
    setPositionMarker("");
    setOpenInfoWindow(false);
  };

  return (
    <MapWrapper>
      {isLoaded && (
        <GoogleMap
          style={{ cursor: showNewRoute ? "pointer" : "inherit" }}
          mapContainerStyle={containerStyle}
          center={center}
          zoom={zoomLevel}
          onLoad={onLoad}
          onUnmount={onUnmount}
          onDragEnd={() => setCenter(map.getCenter().toJSON())}
          onZoomChanged={() => map && (zoomRef.current = map.getZoom())}
          options={{
            styles: GoogleMapStyles,
            draggableCursor: showNewRoute ? "crosshair" : null,
          }}
          // onClick={async (ev) => {
          //   if (categoryId === "122" && showNewRoute) {
          //     setSelectedCoordinates({
          //       lat: ev.latLng.lat(),
          //       lng: ev.latLng.lng(),
          //     });
          //     const location = await getLocationData(
          //       ev.latLng.lat(),
          //       ev.latLng.lng()
          //     ).then((response) => response);
          //     setSelectedLocation(location);
          //     setShowModal(true);
          //   }
          // }}
        >
          {
            <MarkerClusterer options={options} averageCenter>
              {(clusterer) => {
                return formattedData?.map((marker) => {
                  return (
                    <Marker
                      noRedraw={true}
                      title={marker?.title}
                      key={`marker_${marker?.id ?? marker?.mysensor_id}`}
                      position={
                        marker?.position ?? {
                          lat: parseFloat(marker?.lat),
                          lng: parseFloat(marker?.lng),
                        }
                      }
                      clickable
                      clusterer={clusterer}
                      icon={
                        categoryId === "24"
                          ? marker?.isOccupied
                            ? occupiedSpot
                            : availableSpot
                          : marker?.icon ?? defaultMarker
                      }
                      onClick={() => {
                        setOpenInfoWindow(true);
                        selectedItem.setItem(
                          data.filter((item) => item.id === marker?.id)[0]
                        );
                        if (!rightSideBox.isVisible) {
                          rightSideBox.setIsVisible(!rightSideBox.isVisible);
                        }

                        setSelectedMarkerId(marker?.id);
                      }}
                    >
                      {openInfoWindow && selectedMarkerId === marker?.id && (
                        <InfoWindow
                          position={
                            marker?.position ?? {
                              lat: parseFloat(marker?.lat),
                              lng: parseFloat(marker?.lng),
                            }
                          }
                          onCloseClick={() => {
                            setZoomLevel(18);
                            rightSideBox.setIsVisible(!rightSideBox.isVisible);
                          }}
                        >
                          <div
                            style={{
                              width: showNewRoute ? "230px" : "unset",
                            }}
                          >
                            <p style={{ fontSize: "14px", fontWeight: "600" }}>
                              {marker?.title}
                            </p>
                            <p style={{ fontSize: "12px", marginTop: "4px" }}>
                              {marker?.subTitle}
                            </p>
                            {showNewRoute && (
                              <>
                                <hr
                                  style={{
                                    border: "none",
                                    borderBottom: "1px solid rgba(0,0,0,0.25)",
                                  }}
                                />
                                <p
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "400",
                                    color: "blue",
                                    cursor: "pointer",
                                    marginTop: "6px",
                                    borderRadius: "12px",
                                  }}
                                  onClick={() => {
                                    setOpenInfoWindow(false);
                                    newRouteData?.set("step", marker);
                                  }}
                                >
                                  Επιλογή Υποδομής
                                </p>
                              </>
                            )}
                          </div>
                        </InfoWindow>
                      )}
                    </Marker>
                  );
                });
              }}
            </MarkerClusterer>
          }
        </GoogleMap>
      )}
    </MapWrapper>
  );
};

export default MapAMEA;

const MapWrapper = styled.div`
  height: calc(100vh - 100px);
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-block: 30px;
  justify-content: center;
  align-items: center;
`;

// import React, { useCallback, useEffect, useState, useRef } from "react";
// import {
//   GoogleMap,
//   useJsApiLoader,
//   Marker,
//   InfoWindow,
//   MarkerClusterer,
//   Polyline,
// } from "@react-google-maps/api";
// import styled from "styled-components";
// import { Button } from "antd";
// import { useAllContexts } from "../../../hooks/useAllContexts";
// import ViewModal from "../container/ViewModal";
// import { getLocationData } from "../../../services/services";
// import { formatMapData, getMarkerIcon } from "../helpers";
// import { cityCenter } from "../../../../SMARTCITY/hardCodeData/DATA";
// import GoogleMapStyles from "../GoogleMapStyles";
// import {
//   myLocationMarker,
//   locationOnMarker,
//   defaultMarker,
//   baseMarker,
// } from "./Icons";
// import "./MapAMEA.css";
// import "../../categories/mapPOIS/mapsCss.css";

// const libraries = ["visualization", "places"];

// const MapAMEA = ({
//   selectedItem,
//   selectedRoute,
//   rightSideBox,
//   data,
//   selectedCategory,
//   categoryId,
//   showNewRoute,
// }) => {
//   const { newRouteData } = useAllContexts();
//   const { isLoaded } = useJsApiLoader({
//     id: "google-maps-script",
//     googleMapsApiKey: "AIzaSyDQlCnn8F1D0S9ymnWZwc_WFx2ZS6g8w1Q",
//     libraries,
//   });

//   const [map, setMap] = useState(null);
//   const [center, setCenter] = useState(cityCenter);
//   const [zoomLevel, setZoomLevel] = useState(15);
//   const [selectedMarkerId, setSelectedMarkerId] = useState(null);
//   const [openInfoWindow, setOpenInfoWindow] = useState(false);
//   const [formattedData, setFormattedData] = useState([]);
//   const [formattedSelectedItem, setFormattedSelectedItem] = useState(null);
//   const [selectedCoordinates, setSelectedCoordinates] = useState(null);
//   const [selectedLocation, setSelectedLocation] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [positionMarker, setPositionMarker] = useState("");

//   useEffect(() => {
//     if (data) {
//       setFormattedData(
//         data.map((item) =>
//           formatMapData(
//             categoryId,
//             item,
//             selectedCategory === "infra" || showNewRoute ? true : false
//           )
//         )
//       );
//     }
//   }, [data, categoryId, selectedCategory]);

//   useEffect(() => {
//     if (selectedItem.getItem) {
//       setFormattedSelectedItem(
//         formatMapData(
//           categoryId,
//           selectedItem.getItem,
//           selectedCategory === "infra"
//         )
//       );
//     } else {
//       setFormattedSelectedItem(null);
//     }
//   }, [selectedItem.getItem, categoryId, selectedCategory]);

//   useEffect(() => {
//     setCenter({ lat: 40.653582, lng: 22.922504 });
//   }, [selectedCategory]);

//   useEffect(() => {
//     if (formattedSelectedItem) {
//       setZoomLevel(21);
//       setSelectedMarkerId(formattedSelectedItem?.id);
//       setCenter(formattedSelectedItem?.position);
//       setOpenInfoWindow(true);
//     } else {
//       setSelectedMarkerId(null);
//       setOpenInfoWindow(false);
//       setZoomLevel(15);
//       setCenter({ lat: 40.653582, lng: 22.922504 });
//     }
//   }, [formattedSelectedItem, showNewRoute, selectedCategory]);

//   const onLoad = useCallback((map) => setMap(map), []);
//   const onUnmount = useCallback(() => setMap(null), []);

//   const handleMarkerClick = (marker) => {
//     console.log("TEST", marker);
//     // selectedItem.setItem(marker);
//     // console.log(
//     //   "TEST",
//     //   data.find(
//     //     (item) =>
//     //       (categoryId === "122" ? item?.id : item?.mysensor_id) === marker?.id
//     //   )
//     // );
//     selectedItem.setItem(
//       data.find(
//         (item) =>
//           (categoryId === "122" ? item?.id : item?.mysensor_id) === marker?.id
//       )
//     );
//     setSelectedMarkerId(marker?.id);
//     setOpenInfoWindow(true);

//     // if (
//     //   (categoryId === "122" &&
//     //     selectedCategory === "routes" &&
//     //     !showNewRoute) ||
//     //   (categoryId !== "122" && categoryId !== "31")
//     // ) {
//     //   if (!rightSideBox.isVisible) {
//     //     rightSideBox.setIsVisible(true);
//     //   }
//     // }
//   };

//   const handleMapClick = async (ev) => {
//     if (categoryId === "122" && showNewRoute) {
//       const coordinates = { lat: ev.latLng.lat(), lng: ev.latLng.lng() };
//       setSelectedCoordinates(coordinates);
//       const location = await getLocationData(coordinates.lat, coordinates.lng);
//       setSelectedLocation(location);
//       setShowModal(true);
//     }
//   };

//   const setMarkerPosition = (position) => {
//     const tempRoute = { ...newRouteData?.get };
//     tempRoute[position] = {
//       address: selectedLocation?.address.house_number
//         ? `${selectedLocation?.address.road} ${selectedLocation?.address.house_number}`
//         : selectedLocation?.address.road,
//       coordinates: {
//         lat: parseFloat(selectedLocation?.lat),
//         lng: parseFloat(selectedLocation?.lon),
//       },
//     };
//     newRouteData?.set(position, tempRoute);
//     setPositionMarker("");
//     setOpenInfoWindow(false);
//   };

//   const renderMarkers = (clusterer) => {
//     return formattedData?.map((marker) => {
//       return (
//         <Marker
//           key={`marker_${marker?.id ?? marker?.mysensor_id}`}
//           position={
//             marker?.position ?? {
//               lat: parseFloat(marker?.latitude),
//               lng: parseFloat(marker?.longitude),
//             }
//           }
//           title={marker?.title}
//           clickable
//           clusterer={clusterer}
//           icon={marker?.icon ?? defaultMarker}
//           onClick={() => handleMarkerClick(marker)}
//         >
//           {console.log("TEST marker position:", marker?.position.lat)}
//           {openInfoWindow && selectedMarkerId === marker?.id && (
//             <InfoWindow
//               position={marker?.position}
//               // position={{
//               //   lat: marker?.position?.lat
//               //     ? marker?.position.lat
//               //     : marker?.latitude,
//               //   lng: marker?.position?.lng
//               //     ? marker?.position.lat
//               //     : marker?.longitude,
//               // }}
//               // position={
//               //   marker?.position ?? {
//               //     lat: parseFloat(marker?.latitude),
//               //     lng: parseFloat(marker?.longitude),
//               //   }
//               // }
//             >
//               <div style={{ width: showNewRoute ? "230px" : "unset" }}>
//                 <p style={{ fontSize: "14px", fontWeight: "600" }}>
//                   {marker?.title}
//                 </p>
//                 <p style={{ fontSize: "12px", marginTop: "4px" }}>
//                   {marker?.subTitle}
//                 </p>
//                 {showNewRoute && (
//                   <>
//                     <hr
//                       style={{
//                         border: "none",
//                         borderBottom: "1px solid rgba(0,0,0,0.25)",
//                       }}
//                     />
//                     <p
//                       style={{
//                         textAlign: "right",
//                         fontWeight: "400",
//                         color: "blue",
//                         cursor: "pointer",
//                         marginTop: "6px",
//                         borderRadius: "12px",
//                       }}
//                       onClick={() => {
//                         setOpenInfoWindow(false);
//                         newRouteData?.set("step", marker);
//                       }}
//                     >
//                       Επιλογή Υποδομής
//                     </p>
//                   </>
//                 )}
//               </div>
//             </InfoWindow>
//           )}
//         </Marker>
//       );
//     });
//   };

//   const renderRouteMarkers = () => {
//     if (categoryId !== "122" || selectedCategory === "infra") return null;
//     return null;
//     if (selectedRoute?.start) {
//       return (
//         <>
//           <Marker
//             key="start_marker"
//             position={{
//               lat: selectedRoute?.start?.latitude,
//               lng: selectedRoute?.start?.longitude,
//             }}
//             icon={myLocationMarker}
//             title={selectedRoute?.start?.address}
//           />
//           {selectedRoute?.infrastructures?.map((step, id) => (
//             <Marker
//               key={`step_marker_${id}`}
//               position={{ lat: step.latitude, lng: step.longitude }}
//               icon={baseMarker}
//               label={{
//                 className: "step-style",
//                 text: `${id + 1}`,
//                 color: "#fff",
//                 fontSize: "16px",
//               }}
//               title={step.title}
//             />
//           ))}
//           <Marker
//             key="end_marker"
//             position={{
//               lat: selectedRoute?.end?.latitude,
//               lng: selectedRoute?.end?.longitude,
//             }}
//             icon={locationOnMarker}
//             title={selectedRoute?.end?.address}
//           />
//         </>
//       );
//     }
//     return null;
//   };

//   if (!isLoaded) return <div>Loading...</div>;

//   return (
//     <MapWrapper>
//       <GoogleMap
//         mapContainerStyle={{ width: "100%", height: "100%" }}
//         center={center}
//         zoom={zoomLevel}
//         onLoad={onLoad}
//         onUnmount={onUnmount}
//         onClick={handleMapClick}
//         options={{
//           styles: GoogleMapStyles,
//           draggableCursor: showNewRoute ? "crosshair" : null,
//         }}
//       >
//         {/* {newRouteData?.get && categoryId === "122" && showNewRoute && (
//           <>
//             {newRouteData?.get.start.coordinates && (
//               <Marker
//                 position={newRouteData?.get.start?.coordinates}
//                 icon={myLocationMarker}
//                 title={newRouteData?.get.start?.address}
//                 onClick={() => {
//                   setPositionMarker("start");
//                   setOpenInfoWindow(true);
//                 }}
//               >
//                 {openInfoWindow && positionMarker === "start" && (
//                   <InfoWindow>
//                     <p>{newRouteData?.get.start?.address}</p>
//                   </InfoWindow>
//                 )}
//               </Marker>
//             )}
//             {newRouteData?.get.steps?.map((step, id) => {
//               return (
//                 <Marker
//                   key={`step_${id}`}
//                   position={
//                     step.position ?? {
//                       lat: step.latitude,
//                       lng: step.longitude,
//                     }
//                   }
//                   icon={baseMarker}
//                   label={{
//                     className: "step-style",
//                     text: `${id + 1}`,
//                     color: "#fff",
//                     fontSize: "16px",
//                   }}
//                   title={step.title}
//                 />
//               );
//             })}
//             {newRouteData?.get.end?.coordinates && (
//               <Marker
//                 position={newRouteData?.get.end?.coordinates}
//                 icon={locationOnMarker}
//                 title={newRouteData?.get.end?.address}
//                 onClick={() => {
//                   setPositionMarker("end");
//                   setOpenInfoWindow(true);
//                 }}
//               >
//                 {openInfoWindow && positionMarker === "end" && (
//                   <InfoWindow>
//                     <p>{newRouteData?.get.end?.address}</p>
//                   </InfoWindow>
//                 )}
//               </Marker>
//             )}
//           </>
//         )} */}

//         {((selectedCategory === "routes" && showNewRoute) ||
//           selectedCategory !== "routes") && (
//           <MarkerClusterer
//             options={{
//               imagePath:
//                 "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
//             }}
//             averageCenter
//           >
//             {renderMarkers}
//           </MarkerClusterer>
//         )}

//         {selectedCategory === "routes" && !showNewRoute && renderRouteMarkers()}

//         {categoryId === "122" && selectedCategory !== "infra" && (
//           <Polyline
//             path={selectedRoute?.linestring}
//             options={{
//               strokeColor: "rgb(18, 133, 181)",
//               strokeOpacity: 1,
//               strokeWeight: 10,
//             }}
//             geodesic={true}
//           />
//         )}
//       </GoogleMap>

//       {categoryId === "122" && (
//         <ViewModal
//           modalStatus={showModal}
//           title="Επιλογή Σημείου"
//           closeModal={() => setShowModal(false)}
//         >
//           <ModalContainer>
//             <p
//               style={{
//                 textAlign: "center",
//                 width: "400px",
//                 margin: "0 auto",
//                 fontSize: "16px",
//                 fontWeight: "400",
//                 lineHeight: "24px",
//                 letterSpacing: "0.5%",
//               }}
//             >
//               Το σημείο που επιλέξατε αντιστοιχεί στην διεύθυνση:
//             </p>
//             <span
//               style={{
//                 color: "rgb(0,0,180)",
//                 fontWeight: "600",
//                 fontSize: "16px",
//                 letterSpacing: "1px",
//               }}
//             >{`${selectedLocation?.address.road} ${
//               selectedLocation?.address.house_number ?? ""
//             }`}</span>
//             <span
//               style={{ fontSize: "12px" }}
//             >{`Συντεταγμένες: ${selectedCoordinates?.lat.toFixed(
//               6
//             )}, ${selectedCoordinates?.lng.toFixed(6)}`}</span>
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 gap: "10px",
//                 flexWrap: "wrap",
//                 marginTop: "20px",
//               }}
//             >
//               <Button onClick={() => setMarkerPosition("start")}>
//                 Προσθήκη σημείου εκίνησης
//               </Button>
//               <Button onClick={() => setMarkerPosition("end")}>
//                 Προσθήκη σημείου προορισμού
//               </Button>
//             </div>
//           </ModalContainer>
//         </ViewModal>
//       )}
//     </MapWrapper>
//   );
// };

// export default MapAMEA;

// const MapWrapper = styled.div`
//   height: calc(100vh - 100px);
// `;

// const ModalContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 10px;
//   padding-block: 30px;
//   justify-content: center;
//   align-items: center;
// `;
